import { render } from "./Consumer.vue?vue&type=template&id=7c3d1d81"
import script from "./Consumer.vue?vue&type=script&lang=js"
export * from "./Consumer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/otc/Consumer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7c3d1d81"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c3d1d81', __exports__)) {
    api.reload('7c3d1d81', __exports__)
  }
  
  module.hot.accept("./Consumer.vue?vue&type=template&id=7c3d1d81", () => {
    api.rerender('7c3d1d81', render)
  })

}


export default __exports__